module.exports = __webpack_public_path__ + "img/cut-while2.a7fb59f1.png";